import './DetailEmailTicket.css';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { useState, useEffect, useMemo } from 'react';
import { I18n, Storage } from 'aws-amplify';
import LoadingPanel from '../../common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    checkDetailTicket,
    deleteAllTicketData,
    getTicketDetailAPI
} from '@/service/ticketService';
import { FormProvider, useForm } from 'react-hook-form';

// import Atom
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { detailEmailTicketAtom, openReplyDetailEmailAtom } from '@/state/atom/emailTicketAtom';

import { panelInitDataAtom, closeTabId, multiPanelAtom, reloadChatThreadPanelAtom, triggerReloadMenuAtom, reloadTicketDetailIdAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector, setPanelSelector, triggerReloadTab, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';

import { yupResolver } from '@hookform/resolvers';
import CustomSchema from '@/schema/CustomSchema';
import {showLoadingMouse, hideLoadingMouse} from '../../../common/utils/CustomCursor';

import { getPublicAPI } from '@/service/publicService';
import { signOut } from '@/service/authenService';

import { removePanelInitData, updatePanelInitData } from '../../multiPanel/panel/handler/PanelHandler';
import { useSnackbar } from 'notistack';


import { handleCreateReplyEmailTicket, processEmailAddressList, getOriginEmailSubjectValue, handleGetUploadFileList } from './DetailEmailTicketHandler';

// import elements
import HeaderButton from './elements/HeaderButton';
import FooterEmailTicket from './elements/FooterEmailTicket';
import EscalationEmailTicket from './elements/EscalationEmailTicket';
import PaginationButton from './elements/PaginationButton';
import OriginEmailAssignField from './elements/OriginEmailAssignField';
import OriginStatusField from './elements/OriginStatusField';

import ReplyEmailTicketForm from './replyEmailTicket/ReplyEmailTicketForm';
import ContentCurrentEmailTicket from './currentEmailTicket/ContentCurrentEmailTicket';

import { DialogConfirmSoftDeleteTicket } from '../listTicketDialog/DialogConfirmSoftDeleteTicket';
import { handleArchiveTicket, handleBackToArrivalTicket, submitSoftDeleteTicket } from '@/component/chatThread/handler/DetailTicketHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { isTicketCountNumber } from '../handler/TicketHandler';
import { getCorporationDetailByCorporationDomain } from '@/service/organizationService';
import { DialogConfirmChangeTicketError } from '../addTicketDialog/DialogConfirmChangeTicketError';
import { DialogConfirmForceEditTicket } from '../listTicketDialog/DialogConfirmForceEditTicket';
import { DialogConfirmCancelEditTicket } from '../../chatThread/editTicketDialog/DialogConfirmCancelEditTicket';

// behaviors
import { submitUpdateTicket, isInputAllFieldRequiredWhenEditTicket } from '../../chatThread/handler/DetailTicketHandler';
import { getRichTextFieldContent, closePanelTabDetailTicket } from '@/component/ticketList/handler/TicketHandler';
import { createEmailTicketHandler } from '../handler/HelpdeskCreateTicketHandler';
import CopyIdElement from '@/component/common/CopyIdElement';
import { PropTypes } from 'prop-types';
import { triggerReLoadHelpdeskTicketDetailAtom } from '@/state/atom/ticketAtom';

// define props using in this component. targetTicketIdOfChatPost is new field. others fields still working
DetailEmailTicket.propTypes = {
    targetTicketIdOfChatPost: PropTypes.string,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any
};

function DetailEmailTicket(props) {
    // global state
    const selectedProject = useRecoilValue(projectInuseDetailAtom);
    const currentUserDetail = useRecoilValue(userAtom);

    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const setTriggerReloadMenu = useSetRecoilState(triggerReloadMenuAtom);
    const [reloadChatThread ,setReloadChatThread] = useRecoilState(reloadChatThreadPanelAtom);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const reloadTicketDetailId = useRecoilValue(reloadTicketDetailIdAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [statusOfTicket, setStatusOfTicket] = useState({})
    const [newStatusData,setNewStatusData] = useState({})
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const { enqueueSnackbar } = useSnackbar();
    const [triggerEmailTicket, setTriggerEmailTicket] = useRecoilState(detailEmailTicketAtom);
    const [triggerOpenReplyEmail, setTriggerOpenReplyEmail] = useRecoilState(openReplyDetailEmailAtom);
    const isGeneralUser = Utils.isGeneralUser(currentUserDetail);

    // component state
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [detailTicket, setDetailTicket] = useState({});
    const [formDetail, setFormDetail] = useState({});
    const [emailTicketList, setEmailTicketList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [triggerReloadTicket, setTriggerReloadTicket] = useState(0);

    const [isOpenPopupSoftDelete, setIsOpenPopupSoftDelete] = useState(false);
    const [isSoftDelete, setIsSoftDelete] = useState(false);
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);

    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    const [isConfirmDialogObj, setIsConfirmDialogObj] = useState(false);
    const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const [isOpenPopupTicketMsg, setIsOpenPopupTicketMsg] = useState(false);
    const isGeneralUserWithGuest = Utils.isGeneralUser(currentUserDetail);
    const [isDisplayEditTicket, setIsDisplayEditTicket] = useState(false);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [fileDeletedList, setFileDeletedList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [mapDataIdToId, setMapDataIdToId] = useState({});
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [newAssignee, setNewAssignee] = useState('');
    const [statusNo, setStatusNo] = useState(0);
    const [newStatusOfTicket,setNewStatusOfTicket] = useState('')
    const [isHelpDesk, setIsHelpDesk] = useState(false)
    const [isMe, setIsMe] = useState(false);
    const [isEditTicket, setIsEditTicket ] = useState(false);
    const [isDisableEdit, setIsDisableEdit] = useState(false);
    const [newAssigneeData,setNewAssigneeData] = useState({})
    const [currentAssigneeUserData, setCurrentAssigneeUserData] = useState({});
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [projectMailSetting, setProjectMailSetting] = useState(null);
    const [replyToEmailTicket, setReplyToEmailTicket] = useState(null);
    const [toEmailAddressList, setToEmailAddressList] = useState([]);
    const [ccEmailAddressList, setCcEmailAddressList] = useState([]);
    const [bccEmailAddressList, setBccEmailAddressList] = useState([]);
    const [listSuggestSearchEmail, setListSuggestSearchEmail] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowDialogBackToArrivalTicket, setIsShowDialogBackToArrivalTicket] = useState(false);
    const [listTicketChild, setListTicketChild] = useState([])
    const [viewFromProjectOfEscalateTicket, setViewFromProjectOfEscalateTicket] = useState(false);
    const [isShowFlagMsgCopyMsgId, setIsShowFlagMsgCopyMsgId] = useState(false);


    // for edit current ticket
    const [isEditedCurrentTicket, setIsEditedCurrentTicket] = useState(false);
    const [currentTicketDeliverStatus, setCurrentTicketDeliverStatus] = useState(false);
    const [currentTicketFields, setCurrentTicketFields] = useState([])
    const [currentMailSubject, setCurrentMailSubject] = useState('')
    const [currentMailBody, setCurrentMailBody] = useState({value: '', error: ''})
    const [currentAttachmentError, setCurrentAttachmentError] = useState('');
    const [isTriggerReloadCurrentTicket, setIsTriggerReloadCurrentTicket] = useState(false)

    // for reply to email ticket
    const [replyDefaultData, setReplyDefaultData] = useState([]);
    const [isReplyEditData, setIsReplyEditData] = useState(false);
    const [fileReplyUploadList, setFileReplyUploadList] = useState([]);
    const [replyDeliverStatus, setReplyDeliverStatus] = useState(false);
    const [isDisableBtnSave, setIsDisableBtnSave] = useState(true);
    const [replyConfirm, setReplyConfirm] = useState({
        isOpen: false,
        msg: I18n.get('MSG-CM-CANCEL_REPLY'),
        isAction: ''
    });
    const [
        triggerReLoadHelpdeskTicketDetail,
        setTriggerReLoadHelpdeskTicketDetail
    ] = useRecoilState(triggerReLoadHelpdeskTicketDetailAtom);

    const validateReplyTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: yupResolver(CustomSchema(replyDefaultData))
    });
    const handleReplyTicket = validateReplyTicket.handleSubmit;
    const errorReplyTicket = validateReplyTicket.errors;
    const clearErrorReplyTicket = validateReplyTicket.clearErrors;
    const setValueReplyTicket = validateReplyTicket.setValue;
    const registerReplyTicket = validateReplyTicket.register;
    const unregisterReplyTicket = validateReplyTicket.unregister;
    const getValuesReplyTicket = validateReplyTicket.getValues;
    const resetValuesReplyTicket = validateReplyTicket.reset;
    const setErrorReplyTicket = validateReplyTicket.setError;
    // for reply to email ticket

    const validateEditTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListDefaultData))
    });
    const errorEditTicket = validateEditTicket.errors;
    const clearErrors = validateEditTicket.clearErrors;
    const setValueEditTicket = validateEditTicket.setValue;
    const registerEditTicket = validateEditTicket.register;
    const getValuesEditTicket = validateEditTicket.getValues;
    const setErorsEditTicket = validateEditTicket.setError;
    const warpSubmitEditTicket = validateEditTicket.handleSubmit;    
    const [forceEditTicketObject, setForceEditTicketObject] = useState({
        method: 0,
        requestDto: {}
    });
    const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false);

    const currentTabData = useMemo(() => {
        const panel = panelInitData.find(p => p?.id === props?.panelId);
        if (!panel) return;
        const tab = (panel?.tabList || []).find(t => t?.id === props?.tabId)?.data;
        return tab
    }, [panelInitData, props?.tabId, props?.panelId]);

    useEffect(() => {
        const fetchInitData = async () => {
            setIsLoading(true);
            showLoadingMouse();
            
            try {
                const [{ticketDetail, totalPages, emailTickets}, ...res] = await Promise.all([
                    getTicketDetail(props.ticketId, false),
                    initProjectEmailSettingData()
                ]);
                if (!Utils.isEmptyString(props?.targetTicketIdOfChatPost)) {
                    let targetTicketIdx = emailTickets?.findIndex(
                        emailTicket => emailTicket?.id === props?.targetTicketIdOfChatPost
                    );
                    if(targetTicketIdx == -1) targetTicketIdx = totalPages
                    setCurrentPage(targetTicketIdx + 1);
                    if (props.hasOwnProperty('targetTicketIdOfChatPost')) {
                        delete props.targetTicketIdOfChatPost;
                    }
                } else {
                    setCurrentPage(
                        isEditedCurrentTicket
                            ? currentPage > 1 && currentPage < totalPages
                                ? currentPage
                                : totalPages
                            : totalPages
                    );
                }
                setIsEditedCurrentTicket(false);
                
                // reset form
                validateEditTicket?.reset();
                // reset reply ticket
                resetValuesReplyTicket();
                setNewAssignee('')
                setIsEdited(false);
                setIsHelpDesk(true);
            } catch (error) {
                console.error("fetchInitData error:", error);
            } finally {
                setIsLoading(false);
                hideLoadingMouse();
            }
        };
        
        fetchInitData();
    }, [
        props.ticketId,
        selectedProject?.id, 
        props.triggerReload,
        triggerReloadTicket
    ]);

    const handleCloseTab = (isEditedTabTicket, isEditedChildTicket) => {
        const panelType = getPanelType();

        let edited = false
        if (isEditedChildTicket === true) {
            const validateFields = currentTicketIsEdited();
            if (!validateFields) {
                closePanelTabDetailTicket(
                    false,
                    setIsConfirmCancelEditTicket,
                    panelType,
                    props.panelId,
                    detailTicket,
                    panelList,
                    closePanelTab,
                    setCloseTabIdState
                )
                return;
            }
        }

        if (isEditedTabTicket === true || isEditedChildTicket === true) {
            edited = true
        }

        closePanelTabDetailTicket(
            edited,
            setIsConfirmCancelEditTicket,
            panelType,
            props.panelId,
            detailTicket,
            panelList,
            closePanelTab,
            setCloseTabIdState
        )
    }

    // handle close tab
    useEffect(() => {
        if (
            props.tabId === closeTabIdState ||
            (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL && closeTabIdState === detailTicket.id)
        ) {
            handleCloseTab(isEdited, isEditedCurrentTicket)
        }
    }, [closeTabIdState]);

    useEffect(() => {
        if (reloadTicketDetailId.includes(props.ticketId)) {
            setTriggerReloadTicket(Date.now().toString());
        }
    }, [reloadTicketDetailId]);

    // in customer chatthread, user click メール詳細, so open detail ticket
    useEffect(() => {
        if (triggerEmailTicket?.open && !Utils.isEmptyString(triggerEmailTicket?.ticketId)) {
            if (!Utils.isEmptyArray(emailTicketList)) {
                for(let index = 0; index < emailTicketList.length; index++) {
                    if (triggerEmailTicket?.ticketId === emailTicketList[index]?.id && index !== currentPage - 1) {
                        setIsLoading(true)
                        setCurrentPage(index + 1);
                        break;
                    }
                }
            }
            setTriggerEmailTicket({open: false, ticketId: null});
        }
    }, [triggerEmailTicket]);

    // in customer chatthread, user click メール詳細 in footer, so open reply email
    useEffect(() => {
        if (triggerOpenReplyEmail?.open && !Utils.isEmptyString(triggerOpenReplyEmail?.ticketId)) {
            if(!Utils.isEmptyArray(emailTicketList)) {
                if(!triggerOpenReplyEmail?.triggerData?.isOriginTicket) {
                    for(let index = 0; index < emailTicketList.length; index++) {
                        if(triggerOpenReplyEmail?.ticketId === emailTicketList[index]?.id) {
                            openReplyEmail({...emailTicketList[index]}, triggerOpenReplyEmail.triggerData);
                        }
                    }
                }else {
                    openReplyEmail({...emailTicketList[0]}, triggerOpenReplyEmail.triggerData);
                }
            }
            setTriggerOpenReplyEmail({open: false, ticketId: null, triggerData: {}});
        }
    }, [triggerOpenReplyEmail]);

    useEffect(() => {
        let edited = false
        if (isEdited === true || isEditedCurrentTicket === true) {
            edited = true
        }
        updatePanelInitData(
            props?.panelId,
            props?.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            edited
        );
        
    }, [isEdited, isEditedCurrentTicket]);

    useEffect(() => {
        triggerEnableBtnSaveTicket();
    }, [currentTicketDeliverStatus, isEdited, fileReplyUploadList, isEditedCurrentTicket]);

    useEffect(() => {
        const panelHelpdeskTicketList = panelList.filter(panel =>
            [
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            ].includes(panel.type)
        );
        let newPanelList = cloneDeep(panelList);
        panelHelpdeskTicketList?.forEach(panelHelpdeskTicket => {
            let tabDeletedHelpdeskTicket = panelHelpdeskTicket.tabList?.map(tab =>
                tab.id === detailTicket?.id
                    ? {
                          ...tab,
                          isTicketDeleted: !Utils.isEmptyString(detailTicket.deletedAt)
                              ? true
                              : false
                      }
                    : tab
            );
            const newPanelHelpdeskTicket = {
                ...panelHelpdeskTicket,
                tabList: tabDeletedHelpdeskTicket
            };
            newPanelList = newPanelList.map(panel =>
                panel.type === panelHelpdeskTicket.type ? (panel = newPanelHelpdeskTicket) : panel
            );
        });

        setPanelList(newPanelList);
    }, [isSoftDelete])

    useEffect(() => {
        if (Utils.isEmptyArray(emailTicketList)) return;
        
        setIsTriggerReloadCurrentTicket(false);
        
        let page = currentPage > emailTicketList.length ? emailTicketList.length : currentPage;
        let currentEmailTicket = emailTicketList[page - 1];
        let isProjectEmail = currentEmailTicket?.projectOrigin === currentEmailTicket?.affiliationProject;
        let isDeliverStatus = true;
        if (
            currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY &&
            isProjectEmail &&
            currentEmailTicket.deliverInfo &&
            !currentEmailTicket.deliverInfo.status
        ) {
            isDeliverStatus = false;
        }
        
        if (isDeliverStatus === false) setCurrentTicketDeliverStatus(isDeliverStatus);
        
        // when next/back ticket child, get init list field
        setCurrentTicketFields(currentEmailTicket.listField || []);
        
        const listField = currentEmailTicket.listField;
        
        for (let field of listField) {
            switch (field.sysField) {
                case Constant.SYS_FIELD.TO:
                    setToEmailAddressList(field.value || []);
                    break;
                case Constant.SYS_FIELD.CC:
                    setCcEmailAddressList(field.value || []);
                    break;
                case Constant.SYS_FIELD.BCC:
                    setBccEmailAddressList(field.value || []);
                    break;
                case Constant.SYS_FIELD.MAIL_SUBJECT:
                    setCurrentMailSubject(field.value || '');
                    break;
                case Constant.SYS_FIELD.MAIL_BODY:
                    setCurrentMailBody({ value: field.value ? field.value : '', error: '' });
                    break;
                case Constant.SYS_FIELD.ATTACHMENTS:
                    setFileUpdatedList([...field.value]);
                    break;
                default:
                    break;
            }
        }
        
        // handle loading to load attachment when change ticket
        triggerEnableBtnSaveTicket();
        
        const timeoutId = setTimeout(() => {
            console.log('--- change page completed !!!');
            setIsLoading(false);
        }, 1000);
        
        // Cleanup function
        return () => clearTimeout(timeoutId);
        
    }, [currentPage, emailTicketList, isTriggerReloadCurrentTicket]);

   

    const argsAll = {
        ...props,
        API: props?.API,
        panelId: props.panelId,
        corporationDetail,
        selectedProject,
        currentUserDetail,
        setCorporationDetail,
        detailTicket,
        setDetailTicket,
        isLoading,
        setIsLoading,
        fieldListDefaultData,
        setFieldListDefaultData,
        isEdited,
        setIsEdited,
        isDisplayEditTicket,
        setIsDisplayEditTicket,
        fileUploadList,
        setFileUploadList,
        fileUpdatedList,
        fileUploading,
        setFileUploading,
        mapDataIdToId,
        setMapDataIdToId,
        triggerReloadTicket,
        setTriggerReloadTicket,
        newStatusOfTicket,
        statusOfTicket,
        isMe, 
        setIsMe,
        setNewAssignee,
        newAssignee,
        listFieldEdited,
        setListFieldEdited,
        formDetail,
        isHelpDesk,
        panelInitData, 
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        setFileUpdatedList,
        setIsEditTicket,
        forceEditTicketObject,
        setForceEditTicketObject
    };

    const getTicketDetail = async (ticketId, isFromEditTicket=false) => {
        setIsLoading(true);
        //get ticket detail
        let ticketDetailResult = await getTicketDetailAPI(props?.API, ticketId, selectedProject.id, currentUserDetail.id, false);
        // console.log('namnhdebug ticketDetailResult', ticketDetailResult);

        if (!ticketDetailResult || ticketDetailResult?.errors?.length > 0) return;

        let formDetailObject = Utils.convertJSONDataToObject(ticketDetailResult.formDetail);
        let formDetailId = Utils.convertJSONDataToObject(ticketDetailResult?.formDetail)?.id;

        let ticket = ticketDetailResult.detailTicket;
        ticket.dataShareLink = Utils.convertJSONDataToObject(ticketDetailResult?.dataShareLink);
        const createAt = new Date(ticket.createdAt);
        const updatedAt = new Date(ticket.updatedAt);

        ticket.usingFormName = ticketDetailResult.usingFormName;
        ticket.createTime = moment(createAt).format('YYYY/MM/DD HH:mm');
        ticket.updatedTime = moment(updatedAt).format('YYYY/MM/DD HH:mm');

        if (
            selectedProject?.id !== ticket.projectOrigin &&
            selectedProject?.id !== ticket.affiliationProject &&
            !ticket.projectTarget.includes(selectedProject?.id) &&
            ![
                Constant.TICKET_TYPE.TASK,
                Constant.TICKET_TYPE.BROADCAST_PARENT,
                Constant.TICKET_TYPE.BROADCAST_CHILD,
            ].includes(ticket.ticketType)
        ) {
            setViewFromProjectOfEscalateTicket(true);
        }

        // set ticket projectOriginName
        if (ticketDetailResult?.selectedProjectIsProjectOrigin) {
            const projectOrigin = selectedProject;
            let projectOriginName = "";

            if (projectOrigin.type === Constant.PROJECT_TYPE.BASE) {
                projectOriginName = Constant.PROJECT_BASE_DISPLAY_NAME;
            } else {
                projectOriginName = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    projectOrigin.name
                );
            }

            ticket.projectOriginName = projectOriginName;
        }
        // set ticket createrUserName
        if (ticketDetailResult?.currentUserIsCreator) {
            let createrUserName = Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                currentUserDetail
            );
            if (!Utils.isEmptyString(createrUserName)) {
                createrUserName = createrUserName.replace('\n', ' ');
            }
            ticket.createrUserName = createrUserName;
        }

        /**set status value for status field. */
        const status = Utils.convertJSONDataToObject(ticket.status);
        const statusDetail = Utils.convertJSONDataToObject(ticket.statusDetail);
        setStatusNo(statusDetail.no)
        if (!Utils.isEmptyString(status) && !Utils.isEmptyObject(statusDetail)) {
            /**
             * ticket status = done and project setting mail = off. don't allow edit assign and status.
             * status = done and project is not desk on public on. don't allow edit assign and status
             */
            if (
                (!Utils.isEnableCreateEmailTicketMode(corporationDetail, selectedProject) &&
                    statusDetail?.no === Constant.STATUS_NO.DONE) ||
                (statusDetail?.no === Constant.STATUS_NO.DONE &&
                    !Utils.isPublicDesk(selectedProject))
            )
                setIsDisableEdit(true);

            let currentStatusData = {
                status: status,
                currentItemData: {
                    id: status.status,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusDetail.name),
                    no: statusDetail?.structure?.no,
                    color: statusDetail?.structure?.helpdesk?.color,
                    background: statusDetail?.structure?.helpdesk?.background
                }
            };

            if (ticket.affiliationProject !== selectedProject.id) {
                let customerLabel = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    statusDetail.viewForCustomer
                );
                currentStatusData.currentItemData.color = statusDetail?.structure?.customer?.color;
                currentStatusData.currentItemData.background =
                    statusDetail?.structure.customer?.background;
                if (!Utils.isEmptyString(customerLabel)) {
                    currentStatusData.currentItemData.name = customerLabel;
                }
            }
            setStatusOfTicket({ ...currentStatusData });

            // Update status of currentPanelInitData
            if (!Utils.isEmptyObject(currentPanelInitData)) {
                let newCurrentPanelInitData = cloneDeep(currentPanelInitData);
                newCurrentPanelInitData.ticketStatus = currentStatusData.currentItemData;
                if (isFromEditTicket) {
                    newCurrentPanelInitData.formData = {};
                }
                setCurrentPanelInitData(newCurrentPanelInitData);
            }
        }

        /**set value assignment field value into component */
        // const personInCharge = Utils.convertJSONDataToObject(detailTicket?.personInCharge);
        // const personInChargeInfo = Utils.convertJSONDataToObject(detailTicket?.personInChargeInfo);

        /**set field list data info */
        if (ticketDetailResult?.fieldListData) {
            let listField = Utils.convertJSONDataToObject(ticketDetailResult?.fieldListData);
            // console.log('namnhdebug listField', listField)
            //filter field is active
            if (formDetailObject.definition !== Constant.FORM_DEFINITION.SYSTEM) {
                listField = listField?.filter(field => {
                    if (
                        field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                        field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                    ) {
                        return true;
                    }
                    const usingProjectOfField = Utils.convertJSONDataToObject(field?.usingProjects);
                    if (Utils.isEmptyArray(usingProjectOfField)) {
                        return false;
                    } else {
                        return field?.usingProjects?.includes(formDetailObject.affiliationProject);
                    }
                });
            }
            
            if (
                selectedProject.id !== ticket.affiliationProject &&
                (currentUserDetail?.id === ticket.customer ||
                    selectedProject.id === ticket.customer)
            ) {
              
                listField = listField.filter(x => Number(x.publicForCustomer) !== Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW);
                const listFieldPublicForCustomer = listField.filter(
                    field => field.publicForCustomer == Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER
                );
                if (!Utils.isEmptyArray(listFieldPublicForCustomer)) {
                    listField = Array.from(listField, field => {
                        if (Number(field.publicForCustomer) === Constant.SETTING_FORM_DEFAULT.READ_ONLY) {
                            field.structure.required = false;
                        }
                        return field;
                    });
                }
            }

            if (selectedProject.id === ticket.affiliationProject) {
                listField = Array.from(listField, x => {
                    x.publicForCustomer = Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
                    return x;
                });
            }

            if (!Utils.isEmptyObject(ticketDetailResult?.corporationOriginData)) {
                ticket.corporationOriginName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, ticketDetailResult?.corporationOriginData?.name);
            }

            let fieldListDataForEditTicket = [];
            listField.forEach(fieldData => {
                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue:
                        fieldData.type === Constant.FORM_TYPE.FIELD_TAG
                            ? fieldData.defaultValue
                            : fieldData.value
                };
                if (
                    Utils.isAnonymousQAWaitingTicket(ticket) &&  ticket.affiliationProject === selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                } else if (
                    [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(ticket.ticketType) &&
                    fieldDataTmp.sysField === Constant.SYS_FIELD.ATTACHMENTS &&
                    ticket.affiliationProject !== selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                }
                else {
                    fieldDataTmp.structure.publicForCustomer = Number(fieldData.publicForCustomer)
                }

                fieldListDataForEditTicket.push(fieldDataTmp);
            });

            // console.log('namnhdebug fieldListDataForEditTicket', fieldListDataForEditTicket)
           const fieldsValidateInForm = fieldListDataForEditTicket.filter(
               fieldData =>
                   fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW ||
                   fieldData.sysField === Constant.SYS_FIELD.PERSON_IN_CHARGE
           );
            setFieldListDefaultData(fieldsValidateInForm);
            ticket.listField = listField;
        }

        const timeHasPassed = Utils.getTimeToDateNow(createAt);
        ticket.timeHasPassed = timeHasPassed;

        let ticketOutline = ticket.outline ? Utils.convertJSONDataToObject(ticket.outline)?.jp : '';
        ticket.ticketOutline = ticketOutline;

        if (ticket?.listTicketChild) {
            if (!Utils.isEmptyArray(Utils.convertJSONDataToObject(ticket?.listTicketChild))) {
                setListTicketChild([...Utils.convertJSONDataToObject(ticket?.listTicketChild)]);
            }
        }

        ticket = {
            ...ticket,
            deliverInfo: ticket.deliverInfo ? Utils.convertJSONDataToObject(ticket.deliverInfo) : {}
        }
        let tempEmailTicketList = [cloneDeep(ticket)]
        if (ticket.listTicketEmailChild) {
            let listTicketEmailChild = cloneDeep(ticket.listTicketEmailChild);
            let replyTicketList = Utils.convertJSONDataToObject(listTicketEmailChild);
            if (replyTicketList.length > 0) {
                tempEmailTicketList = [...tempEmailTicketList, ...replyTicketList];
            }
            // setReplyTicketList(listTicketEmailChild)
        }
        setEmailTicketList(tempEmailTicketList);
        // setCurrentPage(tempEmailTicketList.length);

           // Check corporationOrigin deleted
           if (
               !Utils.isEmptyObject(ticketDetailResult?.corporationOriginData) &&
               ticketDetailResult.corporationOriginData.active ===
                   Constant.CORPORATION_ACTIVE.DELETED 
           ) {
               setIsDisableEdit(true);
           }

        // For assignee current
        if (ticket?.personInChargeInfo?.avatar) {
            let avatarData = await Storage.get(ticket?.personInChargeInfo?.avatar);
            ticket.personInChargeInfo = {
                ...ticket.personInChargeInfo,
                avatar: avatarData
            }
        }

        let bookmarkData = Utils.convertJSONDataToObject(ticket?.bookmarkInfo)
        ticket.privateBookmarkData = bookmarkData.privateBookmarkData
        ticket.shareBookmarkData = bookmarkData.shareBookmarkData
        ticket.totalPrivateBookmark = bookmarkData.totalPrivateBookmark
        ticket.isBookmarkedDefaultBookmark = bookmarkData.isBookmarkedDefaultBookmark
        ticket.bookmarkListText = bookmarkData.bookmarkListText
        delete ticket.bookmarkInfo

        // set origin ticket
        setDetailTicket(ticket);
        setFormDetail(Utils.convertJSONDataToObject(ticketDetailResult.formDetail));
        if (!Utils.isEmptyObject(ticket?.personInChargeInfo)) {
            setCurrentAssigneeUserData({
                ...ticket?.personInChargeInfo,
                assigneeIcon: ticket?.personInChargeInfo?.shortName,
                assigneeFullName: ticket?.personInChargeInfo?.fullName
            });
        }


        setIsSoftDelete(!Utils.isEmptyString(ticket.deletedAt))
        setIsLoading(false);
        return {ticketDetail: ticket, totalPages: tempEmailTicketList.length, emailTickets: tempEmailTicketList};
    };

    const initProjectEmailSettingData = async () => {
        let paramsGetEmailSetting = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_EMAIL_SETTING,
            projectId: selectedProject.id,
            corporationId: corporationDetail.id,
            sugguestProjectMail: true
        };

        let emailSettingData = await getPublicAPI(props?.API, paramsGetEmailSetting)
        if (emailSettingData.success) {
            const { projectDetail, suggestList } = Utils.convertJSONDataToObject(emailSettingData.payload);
            const mailSetting = projectDetail?.mailSetting ? Utils.convertJSONDataToObject(projectDetail?.mailSetting) : {};

            setProjectMailSetting(mailSetting)
            setListSuggestSearchEmail([...suggestList]);
        }
    }


    const handleSubmitButton = async (formData) => {
        let isReplyTicket = !!replyToEmailTicket;
        console.log('click submit 1 isReplyTicket: ', isReplyTicket);

        let isEditCurrentTicket = currentTicketIsEdited();
        console.log('click submit 2 isEditCurrentTicket: ', isEditCurrentTicket);

        let isEditOriginTicket = isEdited;
        console.log('click submit 3 isEditOriginTicket: ', isEditOriginTicket);

        setIsLoading(true)
        
        if (isReplyTicket) {
            const currentFieldSubject = replyDefaultData.find(f => f.sysField === Constant.SYS_FIELD.MAIL_SUBJECT)
            const submitFormData = getValuesReplyTicket();
            let originSubjectValue = getOriginEmailSubjectValue(emailTicketList, 'Re: ');

            const prefixSubject = 'Re: ';
            if (originSubjectValue?.substring(0, prefixSubject.length) !== prefixSubject) {
                originSubjectValue = prefixSubject + originSubjectValue;
            }

            const isChangedSubjectValue = currentFieldSubject ? submitFormData[currentFieldSubject.id] !== originSubjectValue : false
            
            if (isChangedSubjectValue && replyDeliverStatus === true) {
                console.log('click submit 3 handleCreateNewTicketWhenChangedSubjectAndDelivered: ');
                const fieldListData = [...replyDefaultData, ...fieldListDefaultData].map(f => ({...f,fieldId: f.id}))
                await handleCreateNewTicketWhenChangedSubjectAndDelivered(submitFormData, fieldListData, fileReplyUploadList);
                return;
            };

            console.log('click submit 4 handleSubmitCreateReplyTicket: ');

            await handleSubmitCreateReplyTicket();

        } else if (isEditCurrentTicket) {
            const currentFieldSubject = currentTicketFields.find(f => f.sysField === Constant.SYS_FIELD.MAIL_SUBJECT)
            const originSubjectValue = getOriginEmailSubjectValue(emailTicketList, 'Re: ')

            const isChangedSubjectValue = currentFieldSubject ? currentMailSubject !== originSubjectValue : false

            const fieldListData = [...currentTicketFields, ...fieldListDefaultData].map(f => ({...f,fieldId: f.id}));

            if (isChangedSubjectValue && currentTicketDeliverStatus === true) {
                console.log('click submit 7 handleCreateNewTicketWhenChangedSubjectAndDelivered: ');
                let submitData = {}
                let fileListUploaded = []

                for (let field of fieldListData) {
                    if (field.sysField === Constant.SYS_FIELD.MAIL_SUBJECT) {
                        submitData[field.id] = currentMailSubject
                    }
                    if (field.sysField === Constant.SYS_FIELD.MAIL_BODY) {
                        submitData[field.id] = currentMailBody.value
                    }
                    if (field.sysField === Constant.SYS_FIELD.ATTACHMENTS) {
                        submitData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME] = await handleGetUploadFileList(fileUploadList, fileUpdatedList, fileDeletedList)
                        fileListUploaded = field.value
                    }
                    continue;
                }

                let page = currentPage > emailTicketList.length ? emailTicketList.length : currentPage
                let currentEmailTicket = emailTicketList[page - 1];
                const deleteOldTicketId = currentEmailTicket.id;

                await handleCreateNewTicketWhenChangedSubjectAndDelivered(submitData, fieldListData, fileUploadList, fileListUploaded, deleteOldTicketId);
                return;
            } else {
                console.log('click submit 8 handleSubmitUpdateCurrentTicket: ');
                await handleSubmitUpdateCurrentTicket(fieldListData, currentTicketDeliverStatus, fileUploadList, fileDeletedList, isEditOriginTicket);
            }
        }

        if (!isEditOriginTicket) return;
        console.log('click submit 9 handleSubmitOriginTicket: ');
        // update origin ticket
        await handleSubmitOriginTicket(formData);
    };
    
    const saveAndCancel = async e => {
        let formData = getValuesEditTicket();
        await handleSubmitButton(formData)
        // await handleSubmitOriginTicket(formData, false);
        // handleResetFormData()
    };

    const handleSubmitOriginTicket = async (formData) => {
        const isEditDraftStatus = false;
        const fields = Utils.getEditTicketData(formData, fieldListDefaultData);

        const updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        }
        const editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);

        setIsLoading(true);
        const fieldEdited = currentTabData?.listFieldEdited || listFieldEdited;
        
        const args = {
            ...argsAll,
            listFieldEdited: fieldEdited,
            setIsOpenPopupEditError: setIsOpenPopupTicketMsg
        };

        const updateResult = await submitUpdateTicket(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            isEditDraftStatus,
            args
        );

        if (updateResult?.isConfirm){
            return
        }
        setTriggerReloadTicket(Date.now().toString());

        setIsLoading(false);
        
        // reset submitted listFieldEdited
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', []);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        setIsEdited(false);
        setListFieldEdited([]);
        
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } 

    const onclickReplyTicket = async () => {
        let currentContentTicket = {...emailTicketList[currentPage - 1]};
        openReplyEmail(currentContentTicket);
    }

    const openReplyEmail = (currentContentTicket, triggerData = {}) => {
        let toAddress = [];
        let ccAddress = [];
        let bccAddress = [];

        
        if (!Utils.isEmptyObject(projectMailSetting)) {
            let mailSettingCcAddress = projectMailSetting.ccEmailAddressList.filter(item => !!item)
            let mailSettingBccAddress = projectMailSetting.bccEmailAddressList.filter(item => !!item)
            ccAddress = mailSettingCcAddress;
            bccAddress = mailSettingBccAddress;

        }

        let metaData = Utils.isJson(currentContentTicket?.metaData) ? Utils.convertJSONDataToObject(currentContentTicket?.metaData) :  currentContentTicket?.metaData;
        let metaDataFromValue = metaData?.emailOriginalData?.from?.value;
        console.log('--- metaData', metaData)
        console.log('--- metaData?.emailOriginalData', metaData?.emailOriginalData)

        if (metaDataFromValue && metaDataFromValue[0]) {
            let fromAddress = {
                id:  'new_' +  Date.now(),
                userId:  'new_' +  Date.now(),
                name: metaDataFromValue[0]?.name ? metaDataFromValue[0]?.name : '' ,
                mail: metaDataFromValue[0].address,
            };
            toAddress.push(fromAddress);
        }
        let listField = currentContentTicket?.listField;
        let tmpReplyDefaultData = [];
        listField.map(field => {
            let cloneField = {...field};
            switch (field.sysField) {
                case Constant.SYS_FIELD.TO:
                    if(triggerData && triggerData?.isOriginTicket) {
                        if(!Utils.isEmptyArray(cloneField?.value)) {
                            // Open reply from customer chatthread of origin ticket
                            toAddress.push(...cloneField?.value);

                            //

                        }
                    } else {
                        // remove my self
                        // let toValue = [...cloneField?.value];
                        // let toValueUnique = toValue.filter(to => to.projectId !== selectedProject?.id);
                        // ccAddress = [...ccAddress, ...toValueUnique];
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;
                case Constant.SYS_FIELD.CC:
                    if (!Utils.isEmptyArray(field?.value)) {
                        if(triggerData && triggerData?.isOriginTicket) {
                            // Open reply from customer chatthread of origin ticket
                            ccAddress = [...field?.value];
                        }else {
                            ccAddress = [...ccAddress, ...field?.value];
                        }
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;
                case Constant.SYS_FIELD.BCC:
                    if (!Utils.isEmptyArray(field?.value)) {
                        if(triggerData && triggerData?.isOriginTicket) {
                            // Open reply from customer chatthread of origin ticket
                            bccAddress = [...field?.value];
                        }else {
                            bccAddress = [...ccAddress, ...field?.value];
                        }
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;

                case Constant.SYS_FIELD.MAIL_BODY:
                    let bodyData = {...cloneField};
                    if(triggerData && triggerData?.defaultBody) {
                        bodyData = {...bodyData, defaultValue: triggerData?.defaultBody};
                    }
                    tmpReplyDefaultData.push(bodyData);
                    break;
                case Constant.SYS_FIELD.MAIL_SUBJECT:
                case Constant.SYS_FIELD.ATTACHMENTS:
                    tmpReplyDefaultData.push(cloneField);
                    break;
            
                default:
                    break;
            }
        })

        // Set default value to reply mail
        // Open reply from customer chatthread of origin ticket
        if(!Utils.isEmptyObject(triggerData)) {
            currentContentTicket.listField = tmpReplyDefaultData;
        }

        ccAddress = removeDuplicateInArray(ccAddress)
        bccAddress = removeDuplicateInArray(bccAddress)


        console.log('--- onclickReplyTicket', {ccAddress, bccAddress, toAddress})
        registerReplyTicket('fileUploadList');
        registerReplyTicket('attachments');

        setReplyDefaultData(tmpReplyDefaultData);
        setCcEmailAddressList(ccAddress)
        setBccEmailAddressList(bccAddress)
        setToEmailAddressList(toAddress)
        setReplyToEmailTicket(currentContentTicket);
    }

    const removeDuplicateInArray = (emailList) => {
        const uniqueProjects = emailList.filter((item, index, self) => 
            !item.projectId || 
            index === self.findIndex((t) => t.projectId === item.projectId)
        );

        const uniqueData = uniqueProjects.filter((item, index, self) => 
            !item.mail || 
            index === self.findIndex((t) => t.mail === item.mail)
        );
        return uniqueData;
    }

    const handleSubmitUpdateCurrentTicket = async (
        fieldListData,
        isTicketReplyDeliver = false,
        fileListUpload = [],
        fileListUploaded = [],
        isEditOriginTicket
    ) => {
        try {
            setIsLoading(true);

            const currentEmailTicket = emailTicketList[currentPage - 1]
            const updateData = {
                id: currentEmailTicket.id,
                affiliationOrganization: detailTicket.affiliationOrganization
            }
            let mappingDataIdToIdObj = currentEmailTicket?.mappingDataIdToIdObj || {}
            let isUpdateDraft = false
    
            let formData = {}
            let editedFieldValue = {}
            let listEditedField = []
    
            for(let field of fieldListData) {
                if (field.sysField === Constant.SYS_FIELD.TO) {
                    formData[field.id] = toEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: toEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.CC) {
                    formData[field.id] = ccEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: ccEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.BCC) {
                    formData[field.id] = bccEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: bccEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.MAIL_SUBJECT) {
                    formData[field.id] = currentMailSubject
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: currentMailSubject})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.MAIL_BODY) {
                    formData[field.id] = currentMailBody
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = {value: currentMailBody.value}
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.ATTACHMENTS) {
                    formData[field.id] = currentMailSubject
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: [...fileListUpload, ...fileListUploaded]})
                        }
                    }
                    listEditedField.push(field.id)
                }
            }
            let submitArgs = {
                ...argsAll,
                setIsOpenPopupEditError: () => {},
                setIsLoading: () => {},
                setForceEditTicketObject: () => {},
                setIsMe: () => {},
                isTicketReplyDeliver: isTicketReplyDeliver,
                isEditOriginTicket: isEditOriginTicket,
                listFieldEdited: listEditedField,
            }
    
            const updateResult = await submitUpdateTicket(
                props?.API,
                updateData,
                setIsLoading,
                setIsDisplayEditTicket,
                fileListUpload,
                fileListUploaded,
                setFileUploading,
                setFileUploadList,
                currentEmailTicket,
                fieldListDefaultData,
                formData,
                currentUserDetail,
                editedFieldValue,
                mappingDataIdToIdObj,
                isUpdateDraft,
                submitArgs
            );
    
            if (updateResult?.isConfirm){
                return
            }
            setTriggerReloadTicket(Date.now().toString());
            
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', []);

            reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});
            reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD});

            setListFieldEdited([]);
            setFileUploadList([]);
            setFileDeletedList([]);
            setTimeout(() => {
                setIsLoading(false);
                enqueueSnackbar(
                    isTicketReplyDeliver ? I18n.get('MSG-CM-SEND-TICKET-SUCCESS') : I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'),
                    { variant: 'success', autoHideDuration: 3000 }
                );
            }, 2000);

        } catch (error) {
            console.log('handleSubmitUpdateCurrentTicket error >>>', error)
        }
    }

    const handleSubmitCreateReplyTicket = async () => {
        setIsLoading(true);
        let formData = getValuesReplyTicket();
        console.log('handleSubmitCreateReplyTicket', {formData, fileReplyUploadList, ccEmailAddressList, bccEmailAddressList, toEmailAddressList, replyDeliverStatus});
        let replyResult = await handleCreateReplyEmailTicket(
                toEmailAddressList,
                ccEmailAddressList,
                bccEmailAddressList,
                replyDeliverStatus,
                formDetail,
                formData,
                replyDefaultData,
                fileReplyUploadList,
                corporationDetail,
                currentUserDetail,
                selectedProject,
                replyToEmailTicket
            )

            if (!replyResult) {

            }

        setTriggerReloadTicket(Date.now().toString());

        reloadTicketListByPanelType({panelType: getTicketListType() ? getTicketListType() : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST });
        
        // reset reply data
        clearErrorReplyTicket();
        onClickCancelReplyTicket();
        setTimeout(() => {
            enqueueSnackbar(
                replyDeliverStatus ? I18n.get('MSG-CM-SEND-TICKET-SUCCESS') : I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'),
                { variant: 'success', autoHideDuration: 3000 }
            );
        }, 2000)
    }

    const handleCreateNewTicketWhenChangedSubjectAndDelivered = async (submitFormData, fieldListData, fileListUpload = [], fileListUploaded = [], deleteOldTicketId) => {
        try {
            const newTicketEmail = await createEmailTicketHandler(
                submitFormData,
                currentUserDetail,
                null,
                null,
                null,
                corporationDetail,
                formDetail.id,
                fieldListData,
                {
                    setIsErrorSelected: () => {},
                    toEmailAddressList: toEmailAddressList,
                    ccEmailAddressList: ccEmailAddressList,
                    bccEmailAddressList: bccEmailAddressList,
                    setIsLoading: setIsLoading,
                    fieldListData: fieldListData,
                    setFileUploading: () => {},
                    fileUploadList: fileListUpload,
                    fileUpdatedList: fileListUploaded,
                    projectInuseDetail: selectedProject,
                    selectedForm: formDetail.id,
                    selectedAssigneeUserId: !Utils.isEmptyObject(newAssigneeData) ? newAssigneeData.id : '',
                    API: props?.API,
                    setIsOpenModalReloadPage: () => {},
                    userDetail: currentUserDetail,
                    statusNo: statusNo,
                    enqueueSnackbar: enqueueSnackbar,
                    isUpdatePanelAfterCreatedTicket: false,
                    deleteOldTicketId: deleteOldTicketId
                },
            )
            if (newTicketEmail) {
                // add new tab new ticket
                const panelHelpdeskDetail = panelList.find(p => p.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL)
                addNewPanel({
                    type: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                    tabId: newTicketEmail.id,
                    props: {
                        API: {},
                        panelId: panelInitData[0].id,
                        ticketId: newTicketEmail.id,
                        componentName: Constant.COMPONENT_NAME.TICKET_LIST,
                        ticketListType: Constant.TYPE_GET_TICKET_LIST.HELPDESK,
                        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
                    },
                    ticketId: newTicketEmail.id,
                    ticketOutline: newTicketEmail?.outline,
                    isDraft: false,
                    isEmailTicket: true,
                    isTicketDeleted: false,
                    newPanelId: panelHelpdeskDetail.id || Date.now().toString(),
                    isOpenChat: true,
                    startRelatePanelFromPanelId: panelInitData[0].id,
                });

                // add new tab chat
                setTimeout(() => {
                    const propsClone = cloneDeep(props);
                    delete propsClone?.panelId;
                    addNewPanel({
                        type: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
                        tabId: newTicketEmail.id,
                        currentPanelId: panelHelpdeskDetail.id || Date.now().toString(),
                        isTicketDeleted: false,
                        isShowAllChatPost: false,
                        props: propsClone,
                        ticketOutline: newTicketEmail?.outline,
                        ticketId: newTicketEmail.id,
                        openRelatePanelType: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                        isEmailTicket: true
                    });
                }, 2000);

                reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});
                reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH});
            }
        } catch (error) {
            console.log('createEmailTicketHandler error >>>', error)
        }
    }

    const onClickCancelReplyTicket = () => {
        if (!!replyToEmailTicket) {
            setReplyToEmailTicket(null);
            setCcEmailAddressList([])
            setBccEmailAddressList([])
            setToEmailAddressList([])
            setFileUploadList([])
            setReplyDeliverStatus(false);
            setReplyDefaultData([])
            resetValuesReplyTicket();
            setFileReplyUploadList([]);
            setReplyConfirm({...replyConfirm, isOpen: false})
            triggerEnableBtnSaveTicket();
            setCurrentTicketDeliverStatus(false)
            setIsReplyEditData(false)
        } else { // isEditedCurrentTicket
            setIsEditedCurrentTicket(false)
            setFileUploadList([])
            setIsTriggerReloadCurrentTicket(true)
            setReplyConfirm({...replyConfirm, isOpen: false})
        }
    }

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };
    
    const handleGoToLatestEmail = () => {
        setIsLoading(true);
        setCurrentPage(emailTicketList.length)
        setIsEditedCurrentTicket(false);
        setFileUploadList([]);
    }

    const handleNextEmail = () => {
        if (currentPage < emailTicketList.length) {
            setIsLoading(true);
            setCurrentPage(currentPage + 1);
            setIsEditedCurrentTicket(false);
            setFileUploadList([]);
        }
    };

    const handlePrevEmail = () => {
        if (currentPage > 1) {
            setIsLoading(true);
            setCurrentPage(currentPage - 1);
            setIsEditedCurrentTicket(false);
            setFileUploadList([]);
        }
    };

    const handleSoftDeleteTicket = () => {
        setIsOpenPopupSoftDelete(true);
    }

    const submitSoftDelete = async () => {
        const deletedAt = isSoftDelete
            ? null
            : new Date().toISOString();
        setIsLoading(true);
        if (isSoftDelete) {
            setIsShowDialogRestoreTicket(false);
        }
        let result = await submitSoftDeleteTicket(props?.API, detailTicket, deletedAt, currentUserDetail, argsAll);
        if(result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }
        let {ticketDetail: newTicketDetail, totalPages} = await getTicketDetail(detailTicket.id, false, true);

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        reloadPanelAfterSoftDeleteTicketByPanelType({
            panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            id: detailTicket.id
        });

        // reload escalate ticket
        const customerTicketDetailPanel = panelList.find(p => p.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL);
        if (customerTicketDetailPanel) {
            let updatedTabList = [...customerTicketDetailPanel.tabList];
            if (!Utils.isEmptyArray(updatedTabList)) {
                for (let i = 0; i < updatedTabList.length; i++) {
                    const tab = updatedTabList[i];
                    
                    const isTabCreateNew = tab.id.includes('QA_NEW_TICKET_TAB');
                    if (isTabCreateNew) {
                        const parentTicketIdMatch = tab.id.match(/req_[a-z0-9-]+/);
                        const parentTicketId = parentTicketIdMatch ? parentTicketIdMatch[0] : null;
                        if (parentTicketId && parentTicketId === detailTicket.id) {
                            closePanelTab({
                                event: null,
                                panelType: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL, // customer_ticket_detail
                                panelId: customerTicketDetailPanel.id,
                                tabId: tab.id
                            });
                        }
                    }
                }
            }
        }

        let msgNotiDeleteSuccess = I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY');
        if (isSoftDelete) {
            setIsSoftDelete(false);
            reloadPage();
        } else {
            msgNotiDeleteSuccess = I18n.get('MSG-CM-DELETE-CONTENT-SUCCESSFULLY');
            setIsSoftDelete(true);
        }

        enqueueSnackbar(msgNotiDeleteSuccess, {
            variant: 'success',
            autoHideDuration: 3000
        });
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const reloadPage = () => {
        setTriggerReloadTicket(Date.now().toString());
    }

    const onClickCloseConfirmDialog = () => {
        setIsShowDialogRestoreTicket(false);
        setIsConfirmDialogObj(false);
    }

    const onClickOkConfirmDialog = async () => {
        setIsConfirmDialogObj(false);
        await handleDeleteTicket();
    }

    const handleDeleteTicket = async () => {
        setIsLoading(true);
        let ticketId = detailTicket.id;
        let currentStatusTicket = await checkDetailTicket(props?.API, ticketId);
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
            setIsLoading(false);
            setIsOpenPopupTicketError(true);
            return;
        }
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.INUSED) {
            setIsLoading(false);
            setIsOpenPopupTicketMsg(true);
            return;
        }
        
        let removeOldTicket = await deleteAllTicketData(props?.API, {
            ticketId: ticketId
        });
        if (!removeOldTicket) {
            setIsLoading(false);
            enqueueSnackbar(I18n.get('COMMSG002'), {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }

        if(isTicketCountNumber(detailTicket.ticketType) && detailTicket.affiliationOrganization === corporationDetail.id) {
            let corpDetailResult = await getCorporationDetailByCorporationDomain(props?.API, corporationDetail.organizationDomain);
            setCorporationDetail(corpDetailResult);
        }

        const chatThreadPanelType =
            props.ticketListType === 'helpdesk'
            || props.panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
        
        const chatPanel = panelList.find(panel => panel.type === chatThreadPanelType);

        if (!Utils.isEmptyObject(chatPanel)) {
            closePanelTab({
                event: null,
                isCloseMulti: true,
                closeList: [
                    {
                        panelType: chatThreadPanelType,
                        panelId: chatPanel.id,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    },
                    {
                        panelType: getPanelType(),
                        panelId: props.panelId,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    }
                ]
            });
        } else {
            closePanelTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId:
                    detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                        ? props.ticketId
                        : props.tabId
            });
        }

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        
        let flashMsg = I18n.get('MSG-CM-COMPLETE-DELETE-CONTENT-SUCCESSFULLY');
        enqueueSnackbar(flashMsg, {
            variant: 'success',
            autoHideDuration: 3000
        });

        hideLoadingMouse();
    }

    const handleReloadComponent = () => {
        setIsOpenPopupTicketError(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        closePanelTab({
            event: null,
            panelType: getPanelType(),
            panelId: props.panelId,
            tabId: props.tabId
        });
        closePanelTab({
            event: null,
            panelType:
                props.ticketListType === 'helpdesk'
                    ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                    : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            panelId: props.panelId,
            tabId: props.tabId
        });
    }

    const handleArchiveTicketEmail = async () => {
        let newArgsAll = {
            API: props?.API,
            setIsLoading,
            corporationDetail,
            selectedProject,
            currentUserDetail,
            detailTicket,
            formDetail,
            setIsOpenModalReloadPage,
            setReloadChatThread,
            reloadChatThread
        }
        await handleArchiveTicket(
            props?.API,
            detailTicket,
            setDetailTicket,
            reloadTicketListByPanelType,
            getTicketListType(),
            setTriggerReloadTicket,
            currentUserDetail,
            setTriggerReloadMenu,
            newArgsAll
        )
    }

    const handleAddPanelChatThread = () => {
        // console.log('177259 done handleAddPanelChatThread', props)
        let openRelatePanelType = false;
        if (props.isOpenChat && props) {
            openRelatePanelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
        }
        addNewPanel({
            type: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            tabId: props.ticketId,
            ticketId: props.ticketId,
            props,
            ticketOutline: detailTicket?.ticketOutline,
            isTicketDeleted: !Utils.isEmptyString(detailTicket?.deletedAt) ? true : false,
            isShowAllChatPost: false,
            openRelatePanelType: openRelatePanelType
        });
    }
    
    const setShowButtonEditTicket = (value) => {
        triggerEnableBtnSaveTicket()
    }
    
    const isDisableBtnSaveTicket = () => {
        // show button send
        if (replyToEmailTicket) {
            if (toEmailAddressList.length === 0) return true;

            let toList = processEmailAddressList(toEmailAddressList);
            if (Utils.isEmptyArray(toList)) return true;

            // TODO: check body data => need form provider
            let formData = getValuesReplyTicket();
            let bodyField = replyDefaultData.find(reply => reply.sysField === Constant.SYS_FIELD.MAIL_BODY);
            if (bodyField) {
                let bodyData = formData[bodyField.id] ? formData[bodyField.id] : ''
                let bodyDataText = getRichTextFieldContent(bodyData);
                if (!bodyDataText || bodyDataText === '""') {
                    return true;
                }
            }

            if (!Utils.isEmptyObject(errorReplyTicket)) return true;
    
            return false;
        }

        // check has edit current ticket
        if (currentTicketIsEdited()){
            return false;
        }

        // return false
        if (!isInputAllFieldRequiredWhenEditTicket(fieldListDefaultData, [...fileUploadList, ...fileUpdatedList], getValuesEditTicket)) {
            return true;
        }
        return !isEdited;
    }

    const triggerEnableBtnSaveTicket = () => {
        setIsDisableBtnSave(isDisableBtnSaveTicket());
    }

    const currentTicketIsEdited = () => {
        if (emailTicketList.length > 0) {
            let page = currentPage > emailTicketList.length ? emailTicketList.length : currentPage
            let currentEmailTicket = emailTicketList[page - 1];
            let isProjectEmail = currentEmailTicket?.projectOrigin === currentEmailTicket?.affiliationProject;
            if (
                currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY && 
                isProjectEmail && 
                currentEmailTicket.deliverInfo && 
                !currentEmailTicket.deliverInfo.status &&
                isEditedCurrentTicket
            ) {
                const isInvalid = Utils.isEmptyArray(toEmailAddressList) ||
                    (
                        toEmailAddressList.length === 1 &&
                        !!toEmailAddressList[0].projectId &&
                        toEmailAddressList[0].userList.every(item => !item.selected)
                    ) ||
                    !Utils.isEmptyString(currentMailBody?.error) ||
                    !Utils.isEmptyString(currentAttachmentError)
                
                return isInvalid ? false : true;
            }
            return false;
        }
        return false;
    }

    const handleResetFormData = () => {
        reloadPage();

        validateEditTicket.reset();
        
        // Clear all err
        clearErrors();
        setIsEdited(false);
        setListFieldEdited([]);
        setFileUploadList([]);
    };

    const handleClickBackToArrivalTicket = () => {
        setIsShowDialogBackToArrivalTicket(true)
    }

    const onClickOkConfirmDialogBackToArrival = async () => {
        setIsShowDialogBackToArrivalTicket(false);
        let newArgsAll = {
            API: props?.API,
            setIsLoading,
            enqueueSnackbar,
            setReloadChatThread,
            reloadChatThread,
        }
        await handleBackToArrivalTicket(props?.API,
            detailTicket,
            setDetailTicket,
            reloadTicketListByPanelType,
            getTicketListType(),
            setTriggerReloadTicket,
            currentUserDetail,
            setTriggerReloadMenu,
            setIsLoading,
            setIsOpenModalReloadPage,
            newArgsAll
        );
    }

    let metaData = Utils.isJson(detailTicket?.metaData) ? Utils.convertJSONDataToObject(detailTicket?.metaData) :  detailTicket?.metaData;
    let isRestoredFirstView = metaData?.isRestoredFirstView;
    
    
    const detailEmailPage = currentPage > emailTicketList.length ? emailTicketList.length : currentPage;
    const currentEmailTicket = !Utils.isEmptyArray(emailTicketList) && emailTicketList[detailEmailPage - 1] ? emailTicketList[detailEmailPage - 1] : {};
    let currentChatPostMsgId = '';

    useEffect(() => {
        if (
            props.triggerReload ||
            triggerReloadTicket ||
            triggerReLoadHelpdeskTicketDetail === props.ticketId
        ) {
            getTicketDetail(props.ticketId, false);
            setTriggerReLoadHelpdeskTicketDetail('');
        }
    }, [
        props.triggerReload,
        triggerReLoadHelpdeskTicketDetail,
        props.ticketId,
        triggerReloadTicket
    ]);

    if (currentEmailTicket?.id && detailTicket?.chatPostMessageData) {
        let chatPostMessageData = Utils.convertJSONDataToObject(detailTicket?.chatPostMessageData);
        if (!Utils.isEmptyObject(chatPostMessageData) && chatPostMessageData.hasOwnProperty(currentEmailTicket.id)) {
            currentChatPostMsgId = chatPostMessageData[currentEmailTicket.id];
        }
    }

    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap addTicket-detail">
                    <HeaderButton
                        panelId={props?.panelId}
                        detailTicket={detailTicket}
                        handleSoftDeleteTicket={handleSoftDeleteTicket}
                        selectedProject={selectedProject}
                        currentUserDetail={currentUserDetail}
                        corporationDetail={corporationDetail}
                        handleArchiveTicket={handleArchiveTicketEmail}
                        isSoftDelete={isSoftDelete}
                        isGeneralUserWithGuest={isGeneralUserWithGuest}
                        replyToEmailTicket={replyToEmailTicket}
                        setIsConfirmDialogObj={setIsConfirmDialogObj}
                        setIsShowDialogRestoreTicket={setIsShowDialogRestoreTicket}
                        handleSubmitEditTicket={() => warpSubmitEditTicket(handleSubmitButton)}
                        isDisableBtnSaveTicket={isDisableBtnSaveTicket}
                        onClickCancelReplyTicket={onClickCancelReplyTicket}
                        handleBackToArrivalTicket={handleClickBackToArrivalTicket}
                        currentTicketDeliverStatus={currentTicketDeliverStatus}
                        isEdited={isEdited}
                        isDisableBtnSave={isDisableBtnSave}
                        currentTicketIsEdited={currentTicketIsEdited}
                        triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                        setReplyConfirm={setReplyConfirm}
                        replyConfirm={replyConfirm}
                        isReplyEditData={isReplyEditData}
                        handleCloseTab={handleCloseTab}
                    />

                    <div className="scrollBar-main change-bodR">
                        {isSoftDelete && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        本チケットは削除した日付から30日以内で復元可能です。
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        に自動的に完全削除されます。
                                    </p>
                                </div>
                            </div>
                        )}
                        {isRestoredFirstView && 
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        このメールチケットはゴミ箱から復元されました。
                                    </p>
                                </div>
                            </div>
                        }

                        {!replyToEmailTicket && (
                            <PaginationButton
                                detailTicket={detailTicket}
                                handleNextEmail={handleNextEmail}
                                handlePrevEmail={handlePrevEmail}
                                handleGoToLatestEmail={handleGoToLatestEmail}
                                currentPage={currentPage}
                                totalPages={emailTicketList.length}
                                isLatestEmail={currentPage < emailTicketList.length}
                                handleAddPanelChatThread={handleAddPanelChatThread}
                                currentEmailTicket={
                                    emailTicketList ? emailTicketList[currentPage - 1] : null
                                }
                                isGeneralUser={isGeneralUser}
                                corporationDetail={corporationDetail}
                                selectedProject={selectedProject}
                                currentUserDetail={currentUserDetail}
                                reloadTicketListByPanelType={reloadTicketListByPanelType}
                            />
                        )}
                        

                        <FormProvider {...validateEditTicket}>
                            <OriginEmailAssignField
                                panelId={props?.panelId}
                                tabId={props?.tabId}
                                detailTicket={detailTicket}
                                fieldListDefaultData={fieldListDefaultData}
                                setNewAssignee={setNewAssignee}
                                newAssignee={newAssignee}
                                currentAssigneeUserData={currentAssigneeUserData}
                                setCurrentAssigneeUserData={setCurrentAssigneeUserData}
                                isEdited={isEdited}
                                setIsEdited={setIsEdited}
                                isEditTicket={isEditTicket}
                                setIsEditTicket={setIsEditTicket}
                                isMe={isMe}
                                setIsMe={setIsMe}
                                newAssigneeData={newAssigneeData}
                                setNewAssigneeData={setNewAssigneeData}
                                isDisableEdit={isDisableEdit}
                                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                            />
                            <OriginStatusField
                                detailTicket={detailTicket}
                                selectedAssigneeUserId={newAssignee}
                                isDisableEdit={isDisableEdit}
                                API={props?.API}
                                setShowButtonEditTicket={setShowButtonEditTicket}
                                setNewStatusOfTicket={setNewStatusOfTicket}
                                setNewStatusData={setNewStatusData}
                                newStatusData={newStatusData}
                                listFieldEdited={listFieldEdited}
                                setOnChangeEdit={() => {}}
                                setListFieldEdited={setListFieldEdited}
                                statusDetail={statusOfTicket?.status}
                                isHelpDesk={isHelpDesk}
                                setStatusNo={setStatusNo}
                                currentPanelInitData={currentPanelInitData}
                                currentItemData={statusOfTicket?.currentItemData}
                                fieldListDefaultData={fieldListDefaultData}
                                setIsEdited={setIsEdited}
                            />
                        </FormProvider>

                        {/* Message ID */}
                        <div className="form-addTicket">
                            <div className='form-addTicket-label message-id-content'>
                                {I18n.get('LABEL-MESSAGE-ID')} :
                                    <CopyIdElement
                                        key={`copy-msg-${currentChatPostMsgId}`}
                                        copyId={currentChatPostMsgId}
                                        messageShareLink={currentChatPostMsgId}
                                        isShow={true}
                                        title={I18n.get(
                                            'LABEL-CHATPOST-SHARELINK-TOOLTIP'
                                        )}
                                        flagMessage={I18n.get(
                                            'MSG-COPY-SHARELINK'
                                        )}
                                    />
                                <span>{currentChatPostMsgId}</span>
                            </div>
                        </div>

                        {!Utils.isEmptyArray(listTicketChild) && isHelpDesk && (
                            <EscalationEmailTicket
                                props={props}
                                isHelpDesk={isHelpDesk}
                                listTicketChild={listTicketChild}
                                viewFromProjectOfEscalateTicket={viewFromProjectOfEscalateTicket}
                                addNewPanel={addNewPanel}
                            />
                        )}
                                            
                        {replyToEmailTicket ? ( 
                                <ReplyEmailTicketForm
                                    originTicket={detailTicket}
                                    currentEmailTicket={emailTicketList ? emailTicketList[currentPage - 1] : null}
                                    onclickReplyTicket={onclickReplyTicket}
                                    replyToEmailTicket={replyToEmailTicket}
                                    toEmailAddressList={toEmailAddressList}
                                    setToEmailAddressList={setToEmailAddressList}
                                    ccEmailAddressList={ccEmailAddressList}
                                    setCcEmailAddressList={setCcEmailAddressList}
                                    bccEmailAddressList={bccEmailAddressList}
                                    setBccEmailAddressList={setBccEmailAddressList}
                                    listSuggestSearchEmail={listSuggestSearchEmail}
                                    setIsEdited={setIsReplyEditData}
                                    errorlist={errorReplyTicket}
                                    register={registerReplyTicket}
                                    setValue={setValueReplyTicket}
                                    getValues={getValuesReplyTicket}
                                    setError={setErrorReplyTicket}
                                    clearErrors={clearErrorReplyTicket}
                                    fileReplyUploadList={fileReplyUploadList}
                                    setFileReplyUploadList={setFileReplyUploadList}
                                    replyDeliverStatus={replyDeliverStatus}
                                    setReplyDeliverStatus={setReplyDeliverStatus}
                                    currentTicketDeliverStatus={currentTicketDeliverStatus}
                                    setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                    triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                />
                        ) : (
                            <ContentCurrentEmailTicket
                                originTicket={detailTicket}
                                currentEmailTicket={
                                    emailTicketList ? emailTicketList[currentPage - 1] : null
                                }
                                onclickReplyTicket={onclickReplyTicket}
                                replyToEmailTicket={replyToEmailTicket}
                                setIsEdited={setIsEdited}
                                currentTicketDeliverStatus={currentTicketDeliverStatus}
                                setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                isEditedCurrentTicket={isEditedCurrentTicket}
                                setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                isDisableEdit={isDisableEdit}
                                setIsShowPopupLogout={setIsShowPopupLogout}

                                currentTicketFields={currentTicketFields}
                                toEmailAddressList={toEmailAddressList}
                                setToEmailAddressList={setToEmailAddressList}
                                ccEmailAddressList={ccEmailAddressList}
                                setCcEmailAddressList={setCcEmailAddressList}
                                bccEmailAddressList={bccEmailAddressList}
                                setBccEmailAddressList={setBccEmailAddressList}
                                listSuggestSearchEmail={listSuggestSearchEmail}
                                currentMailSubject={currentMailSubject}
                                setCurrentMailSubject={setCurrentMailSubject}
                                currentMailBody={currentMailBody}
                                setCurrentMailBody={setCurrentMailBody}
                                currentAttachmentError={currentAttachmentError}
                                setCurrentAttachmentError={setCurrentAttachmentError}

                                fileUploadList={fileUploadList}
                                setFileUploadList={setFileUploadList}
                                fileUpdatedList={fileUpdatedList}
                                setFileUpdatedList={setFileUpdatedList}
                                fileDeletedList={fileDeletedList}
                                setFileDeletedList={setFileDeletedList}
                                
                                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                isTriggerReloadCurrentTicket={isTriggerReloadCurrentTicket}
                            />
                        )}

                        <FooterEmailTicket
                            detailTicket={detailTicket}
                            formDetail={formDetail}
                            currentEmailTicket={
                                emailTicketList ? emailTicketList[currentPage - 1] : null
                            }
                        />
                    </div>

                    <DialogConfirmCancelEditTicket
                        saveAndCancel={saveAndCancel}
                        isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                        setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                        setCloseTabIdState={setCloseTabIdState}
                        detailTicket={detailTicket}
                        // Draft
                        submitSentDraft={() => {}}
                        handleResetFormData={handleResetFormData}
                        handleCancelTicket={() => {
                            setIsEdited(false)
                            removePanelInitData(props?.panelId, props?.tabId, panelInitData, setPanelInitData);
                            const resetIsEdited = false
                            handleCloseTab(resetIsEdited)
                        }}
                    />

                    <DialogConfirmSoftDeleteTicket
                        isOpen={isOpenPopupSoftDelete}
                        setIsOpen={setIsOpenPopupSoftDelete}
                        submitSoftDelete={submitSoftDelete}
                        detailTicket={detailTicket}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogRestoreTicket}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={submitSoftDelete}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <DataChangePleaseReloadModal
                        {...argsAll}
                        isOpen={isOpenModalReloadPage}
                        setIsOpen={setIsOpenModalReloadPage}
                    />
                    <ConfirmDialog
                        isOpen={isConfirmDialogObj}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={onClickOkConfirmDialog}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenPopupTicketError}
                        okCallBack={handleReloadComponent}
                        msgConfirm={I18n.get('COMMSG068')}
                        textSubmit={I18n.get('COMBTN006')}
                    />

                    {/* <ConfirmDialog
                        isOpen={isConfirmDialogObj}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-PERMANENTLY-CONTENT')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={onClickOkConfirmDialog}
                        textClose={I18n.get('COMBTN007')}
                    /> */}


                    <DialogConfirmChangeTicketError
                        {...argsAll}
                        isOpen={isOpenPopupTicketMsg}
                        setIsOpen={setIsOpenPopupTicketMsg}
                    />
                    <DialogConfirmForceEditTicket
                        API={props?.API}
                        setIsLoading={setIsLoading}
                        confirmForceEditTicket={forceEditTicketObject}
                        setConfirmForceEditTicket={setForceEditTicketObject}
                        panelList={panelList}
                        setPanelList={setPanelList}
                        setAssignListPopover={() => {}}
                        triggerReload={setTriggerReloadTicket}
                        panelId={props?.panelId}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogBackToArrivalTicket}
                        msgConfirm={I18n.get('MSG-CM-CONFIRM-BACK-TO-NEW-SUPPORT')}
                        closeCallBack={e => setIsShowDialogBackToArrivalTicket(false)}
                        okCallBack={onClickOkConfirmDialogBackToArrival}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={replyConfirm.isOpen || false}
                        msgConfirm={replyConfirm.msg}
                        closeCallBack={e => setReplyConfirm({...replyConfirm, isOpen: false})}
                        okCallBack={onClickCancelReplyTicket}
                        textClose={I18n.get('CM-BUTTON-CANCEL')}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isShowPopupLogout}
                        msgConfirm={<div><span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                        textSubmit={I18n.get('CM-BUTTON-OK')}
                        okCallBack={() => signOut()}
                        cancelCallBack={() => setIsShowPopupLogout(false)}
                        cancelClassName={'btn-confirm-cancel'}
                    />
                </div>
            )}
        </div>
    );
}

export default DetailEmailTicket;
